import React, { useRef } from "react";

interface ISliderProps {
    percentage: number;
    label?: string;
    callbackIncrease: () => void;
    callbackDecrease: () => void;
    callbackMove: (percent: number) => void;
}

const Slider: React.FC<ISliderProps> = ({
    percentage,
    label,
    callbackIncrease,
    callbackDecrease,
    callbackMove
}) => {    
    const sliderRef = useRef<any>(null);

    const handleDecrease = () => {
        callbackDecrease()
    }

    const handleIncrease = () => {
        callbackIncrease();
    }

    const handleMove = (e: any) => {
        if (sliderRef.current) {
            const { width, x } = sliderRef.current.getBoundingClientRect();          

            // Calculating percentage
            let percent = (100 * (e.clientX - x)) / width;
            if (percent >= 0 && percent <= 100) {
                callbackMove(Math.round(percent));
            }
        }
    }   

    return (
        <div className="select-none">
            {
                label &&
                <div className="font-semibold text-[15px] leading-[18px] mb-[14px]">{label}</div>
            }

            <div className="flex items-center">
                {/* MINUS */}
                <div onClick={handleDecrease} className="cursor-pointer shrink-0 mr-5">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4 stroke-red">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12h-15" />
                    </svg>
                </div>

                <div ref={sliderRef} className="relative h-2 bg-[#E9E8E8] grow rounded-full">
                    <div onDrag={handleMove} draggable={true} style={{ left: percentage + '%' }} className="dont-show-drag select-none cursor-grab touch-none absolute -translate-x-1/2 top-1/2 -translate-y-1/2 w-1 h-5 bg-red">
                        <div className="absolute mt-[3px] ml-[3px] top-full left-1/2 -translate-x-1/2 w-max text-xs leading-[14.5px] font-bold">
                            {percentage}%
                        </div>
                    </div>
                </div>

                {/* PLUS */}
                <div onClick={handleIncrease} className="cursor-pointer shrink-0 ml-5">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} className="w-4 h-4 stroke-red">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                    </svg>
                </div>
            </div>
        </div>

    );
}

export default Slider;